module.exports = __webpack_public_path__ + "static/media/icon-tick-green.58315b93.svg";